import React from 'react'
import CommonNavbar from '../../Navbar/CommonNavbar'

const ReportHeader = ({ onSearch, disableSearch = false }) => {
  return (
    <div>
    <header>
        <nav className="nav-items" >
            <p>Report</p>
           <CommonNavbar onSearch={onSearch} disableSearch={disableSearch} />
        </nav>
        </header>
    </div>
  )
}

export default ReportHeader
